<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t("menu.collezioni_aperte") }}
        </div>
      </div>
      <div class="area-description" v-html="pageDescription"></div>

<!--      <vueper-slides-->
<!--          id="vueperslides"-->
<!--          ref="vueperslides"-->
<!--          class="no-shadow"-->
<!--          :visible-slides="2"-->
<!--          slide-multiple-->
<!--          fixed-height="100px"-->
<!--          arrows-outside-->
<!--          bullets-outside-->
<!--          :breakpoints="{ 1300: { visibleSlides: 1, fixedHeight: 100, arrows: false },-->
<!--          1000: { visibleSlides: 1, fixedHeight: 220, arrows: false } }">-->
<!--        <vueper-slide-->
<!--            v-for="coll in collections"-->
<!--            :key="coll.id"-->
<!--            style="display: flex; align-items: center;justify-content: center;"-->
<!--            @click.native="setCurrentId(coll.id)">-->
<!--          <template #content>-->
<!--            <div>-->
<!--              <div :id="'coll-' + coll.id" :style="(currentId == coll.id ? 'text-decoration: underline;' : '')">{{ $utilities.getTranslation(coll, "titolo", $i18n.locale) }}</div>-->
<!--            </div>-->
<!--          </template>-->
<!--        </vueper-slide>-->
<!--      </vueper-slides>-->

      <div id="map-main-div">
        <div id="map-assets" class="border w-100 mb-4">
          <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
                  data-projection="EPSG:4326" ref="map">

            <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>

            <vl-layer-tile id="osm">
              <vl-source-osm></vl-source-osm>
            </vl-layer-tile>

            <vl-overlay
                class="map-overlay"
                v-for="collection in collections"
                :key="collection.id"
                :position="[collection.luogo.longitudine, collection.luogo.latitudine]">
              <template>
                  <div style="cursor: pointer">
                    <div :class="currentId == collection.id ? 'map-circle-on' : 'map-circle-off'" @click="setCurrentId(collection.id)" style="cursor: pointer"></div>
                    <b-link :to="'/assets/' + collection.id">
                      <p v-if="currentId == collection.id" class="ml-1 asset-card-title2 bg-light">{{ translatedCollectionName + " ▶" }}</p>
                    </b-link>
                  </div>
              </template>
            </vl-overlay>
          </vl-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {VueperSlides, VueperSlide} from 'vueperslides'
// import 'vueperslides/dist/vueperslides.css'

export default {
  name: 'MapCollections',
  // components: {VueperSlides, VueperSlide},
  data: function() {
    return {
      pageDescriptionRecord: "",
      zoom: 10, // TODO: zoom su box indipendente dalla risoluzione
      center: [10.15, 45.38],
      rotation: 0,
      loading: "(" + this.$t("caricamento") + "...)",
      collectionIds: [91, 53, 105, 47, 118, 78, 93],
      collections: [],
      currentId: null,
    };
  },
  created() {
    this.fetchTexts();
    this.fetchCollections();
  },
  computed: {
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
        }
      return desc;
    },
    translatedCollectionName() {
      for (let coll in this.collections)
        if (this.collections[coll].id == this.currentId)
          return this.$utilities.getTranslation(this.collections[coll], "nome", this.$i18n.locale);
      return "";
    },
    getPlaceTranslation(place) {
      return this.$utilities.getTranslation(place, "denominazione", this.$i18n.locale);
    },
  },
  methods: {
    // Recupera le collezioni di scavi archeologici
    async fetchTexts() {
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'collezioni_aperte'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];
    },
    async fetchCollections() {
      if (this.collectionIds.length == 0)
        return;
      const collectionsData = await this.$client.getItems("collezioni", {fields: ["*", "traduzioni.*"], filter: {
          id: {
            in: this.collectionIds
          },
          luogo: {
            neq: null
          }
        }
      });
      let collections = collectionsData.data;
      let placesIds = "";
      for (let coll in collections)
        placesIds += collections[coll].luogo.id + ",";

      const places = await this.$client.getItems("luoghi", {
        fields: ["id", "longitudine", "latitudine", "traduzioni.*"], limit: -1, filter: { id: { in: placesIds } }
      });
      let placesData = places.data;
      for (let coll in collections) {
        if (collections[coll].luogo != null) {
          for (let i in placesData) {
            if (placesData[i].id == collections[coll].luogo.id) {
              collections[coll].luogo.record = placesData[i];
              collections[coll].luogo.longitudine = placesData[i].longitudine;
              collections[coll].luogo.latitudine = placesData[i].latitudine;
            }
          }
        }
      }

      this.collections = collections;
    },
    setCurrentId(id) {
      this.currentId = id;
      for (let i in this.collections)
        if (this.collections[i].id == id)
          this.$refs.map.$map.getView().fit(this.$refs.map.pointToViewProj(
              [this.collections[i].luogo.longitudine - 0.01, this.collections[i].luogo.latitudine - 0.01]).concat(this.$refs.map.pointToViewProj(
              [this.collections[i].luogo.longitudine + 0.01, this.collections[i].luogo.latitudine + 0.01])));
    },
    openLocation(id) {
      document.getElementById("coll-" + id).click();
    }
  }
}
</script>

<style>
</style>
